import React, {useEffect, useState, useMemo} from "react";

const darkMode = false;

export const BACKGROUND = '#ffffff';

export const GRAY_LIGHT = '#e6e6e6';
export const GRAY_MEDIUM = '#cacaca';
export const GRAY_DARK = '#737475';

export const DARK_BLUE = '#2b3087';

export const PRM_BLUE = '#3b7ab4';
export const PRM_LIGHT_BLUE = darkMode ? 'white' : '#307FE2';
export const PRM_DARK_BLUE = '#1e22aa';
export const TEXT_COLOR = darkMode ? 'white' : 'black';
export const SIDEBAR_COLOR = darkMode ? 'black' : '#307FE2';
export const BACKGROUND_COLOR = darkMode ? '#121212' : 'white';

export const SUNFLOWER_YELLOW = "#dbdb12";

export const DAA_GREEN = "#417c3d";
